import apolloClient from 'api/apolloClient';
import { getCelticUsersForSponsorByType } from 'api/operations/userService';
import { makeAutoObservable, runInAction } from 'mobx';
import { AccountRepresentative, Assignee, InputAgentOfRecord } from 'types/groupService';
import { CelticType } from 'types/userService';
import { GET_ASSIGNEES_AND_AGENTS_OF_RECORDS } from 'api/queries/groupService';
import { requestAgentsOfRecord } from 'api/operations/groupService';

//* TO_DO-AOR: Cover with units */
export const convertAoRToInput = (agentOfRecord?: Assignee | null): InputAgentOfRecord => {
  return agentOfRecord
    ? {
        id: agentOfRecord.id,
        name: agentOfRecord.name,
        npn: agentOfRecord.npn,
        tin: agentOfRecord.tin,
      }
    : { id: '', name: '', npn: '', tin: '' };
};

//* * Agents are set per agency, hence don't change in scope of BrokerPortal */
export class AgentsStore {
  private _assignees: Assignee[] = [];
  private _agentsOfRecord: Assignee[] = [];
  private _accountRepresentatives: AccountRepresentative[] = [];

  private _isLoading = false;

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get assignees(): Assignee[] {
    return this._assignees;
  }

  public get agentsOfRecord(): Assignee[] {
    return this._agentsOfRecord;
  }

  public get accountRepresentatives(): AccountRepresentative[] {
    return this._accountRepresentatives;
  }

  public setLoading(status: boolean): void {
    this._isLoading = status;
  }

  /** 
   @deprecated use operations instead
   */
  public async requestAgentsAndAssignees(agencyId?: string): Promise<void> {
    const res = await apolloClient.query<{ getAgentsOfRecord: Assignee[]; getAssignees: Assignee[] }>({
      query: GET_ASSIGNEES_AND_AGENTS_OF_RECORDS,
      fetchPolicy: 'no-cache',
      variables: { agencyId },
    });
    await runInAction(async (): Promise<void> => {
      this._assignees = res.data.getAssignees;
      this._agentsOfRecord = res.data.getAgentsOfRecord;
      const accountRepRes = await getCelticUsersForSponsorByType(CelticType.ACCOUNT_REP_CELTICS);
      runInAction((): void => {
        this._accountRepresentatives = accountRepRes.data.getCelticUsersForSponsorByType;
      });
    });
  }

  public async requestAgents(): Promise<void> {
    this.setLoading(true);
    const agents = await requestAgentsOfRecord();
    runInAction(() => {
      this._agentsOfRecord = agents;
      this.setLoading(false);
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
